import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { createMaterialOptionLabel } from "commons/ultilities/option-item/label-ultil";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type { AutoCompleteProvider } from "./factory";

export const materialAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword) => {
    return materialBusiness.searchMaterialsAsOptionItems(keyword);
  },
  searchOptionItemsPagedAsync: async (keyword, request) => {
    const materials = await materialBusiness.getLists({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
    });

    return {
      items: mapToDistinctOptionItems(
        materials.items,
        (item) => item.id,
        (item) => createMaterialOptionLabel(item),
      ),
      totalCount: materials.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const material = await materialBusiness.getById(normalizedId);
      if (!material?.id) {
        return null;
      }

      return {
        value: material.id,
        label: createMaterialOptionLabel(material),
      };
    } catch {
      return null;
    }
  },
};
